import { Go2Zero } from "./Go2Zero";
import { CarbonPulse } from "./CarbonPulse";

export const FILE_TYPES = [Go2Zero, CarbonPulse];
